import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const MenuActionLink = styled.a<{ disabled?: boolean }>(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
    fontFamily: theme(props).typography.fontFamily.regular,
    color: props.disabled ? theme(props).typography.link.inactiveColor : theme(props).typography.primary.color,
    lineHeight: "20px",
    padding: "6px 12px 6px 8px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textDecoration: "none",
    borderRadius: "8px",
    cursor: props.disabled ? "default" : "pointer",
    userSelect: "none",
    backgroundColor: "transparent",

    ":hover": {
        backgroundColor: theme(props).lists.items.accentLow.backgroundColor,
    },
}));

export const MenuActionButton = styled.button<{ disabled?: boolean }>(props => ({
    fontFamily: theme(props).typography.fontFamily.regular,
    color: props.disabled ? theme(props).typography.link.inactiveColor : theme(props).typography.primary.color,
    padding: "6px 12px 6px 8px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textDecoration: "none",
    borderRadius: "8px",
    cursor: props.disabled ? "default" : "pointer",
    userSelect: "none",
    border: "none",
    backgroundColor: "transparent",
    ...theme(props).typography.primary.css(),

    ":hover": {
        backgroundColor: theme(props).lists.items.accentLow.backgroundColor,
    },
}));

export const MenuActionText = styled.span(() => ({
    marginLeft: "8px",
}));
